import { COLORS } from '../../../v3/global';
import './nps-detractors-passives-modal.styles.scss';
type Props = {
  nps: any;
  role: string;
};

const NoResponseRow = ({ nps, role }: Props) => {
  const getPhoneNumberAnchor = () => {
    const phoneNumber = nps?.from?.phoneNumber?.number
      ? `${nps?.from?.phoneNumber?.countryCode ?? ''}${nps?.from?.phoneNumber?.number ?? ''}`
      : nps?.from?.phoneNumber;
    const parentPhoneNumber = nps?.from?.parentData?.phoneNumber?.number
      ? `${nps?.from?.parentData?.phoneNumber?.countryCode ?? ''}${
          nps?.from?.parentData?.phoneNumber?.number ?? ''
        }`
      : nps?.from?.parentData?.phoneNumber;

    if (role === 'parent' && (parentPhoneNumber || phoneNumber)) {
      return (
        <a
          href={`tel:${parentPhoneNumber ? parentPhoneNumber : phoneNumber}`}
          target="_blank"
          rel="noreferrer"
        >
          {parentPhoneNumber ? parentPhoneNumber : `${phoneNumber} (student)`}
        </a>
      );
    }

    if (phoneNumber) {
      return (
        <a href={`tel:${phoneNumber}`} target="_blank" rel="noreferrer">
          {phoneNumber}
        </a>
      );
    }

    return '-';
  };

  return (
    <tr>
      {/*NAME*/}
      <td>
        <div style={{ color: COLORS.TEXT_PRIMARY }} className="modal-row-column-text">
          {role === 'parent'
            ? (nps?.from?.parentData.fullName ?? '-') + ' (' + (nps?.from?.fullName ?? '-') + ')'
            : nps?.from?.fullName ?? '-'}
        </div>
      </td>

      {/*RATING*/}
      <td>
        <span style={{ color: COLORS.TEXT_PRIMARY }} className="modal-row-column-text">
          -
        </span>
      </td>

      {/*REASONS*/}
      <td>
        <div style={{ color: COLORS.TEXT_PRIMARY }} className="modal-row-column-text">
          -
        </div>
      </td>

      {/*CONTACT*/}
      <td>
        <div
          style={{ color: COLORS.TEXT_PRIMARY }}
          className="modal-row-column-text NPS-modal-table-contact-span"
        >
          {getPhoneNumberAnchor()}
        </div>
        <div style={{ color: COLORS.TEXT_PRIMARY }} className="modal-row-column-text">
          {nps?.from?.email ? (
            <a
              href={`mailto:${role === 'parent' ? nps?.from?.parentData.email : nps?.from?.email}`}
              target="_blank"
              rel="noreferrer"
            >
              {role === 'parent' ? nps?.from?.parentData.email : nps?.from?.email}
            </a>
          ) : (
            '-'
          )}
        </div>
      </td>
    </tr>
  );
};

export default NoResponseRow;
